import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c2865c50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-name" }
const _hoisted_2 = { id: "login-btn-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Выйти?", -1))
const _hoisted_4 = { style: {"display":"flex","justify-content":"space-between","width":"100%","margin-top":"1em"} }

import ButtonClose from '@/components/UI/ButtonClose.vue';
    import ButtonCustom from '@/components/UI/ButtonCustom.vue';
    import ModalWindow from '@/components/UI/ModalWindow.vue';

    import LoginModule from '@/components/Auth/LoginModule.vue';
    import RegisrationModule from '@/components/Auth/RegistrationModule.vue';

    import type { Ref } from 'vue'
    import { computed, ref} from 'vue';
    import { useStore } from 'vuex';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AuthModule',
  emits: ['close'],
  setup(__props, { emit }) {

    const store = useStore()

    let userName = computed(() => store.getters.userName ) 

    // хардкод!
    // let userName = 'gignhit'

    let tokenDefined = computed(() => {
        if ( store.getters.token == null ) {
            return false
        } else {
            return true
        }
    })

    

    let showModal = ref(false)
    let showAuthModal = ref(false)

    let showLogin = ref(true)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(tokenDefined))
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", null, _toDisplayString(_unref(userName)), 1),
            _createVNode(ButtonClose, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(showModal) //@ts-ignore
 ? showModal.value = true : showModal = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("x")
              ]),
              _: 1
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("section", {
          key: 1,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createElementVNode("p", _hoisted_2, [
            _createVNode(ButtonCustom, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_isRef(showAuthModal) //@ts-ignore
 ? showAuthModal.value = true : showAuthModal = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Войти")
              ]),
              _: 1
            })
          ])
        ])),
    (_unref(showAuthModal))
      ? (_openBlock(), _createBlock(ModalWindow, {
          key: 2,
          showbtn: true,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_isRef(showAuthModal) //@ts-ignore
 ? showAuthModal.value = false : showAuthModal = false))
        }, {
          default: _withCtx(() => [
            (_unref(showLogin))
              ? (_openBlock(), _createBlock(LoginModule, {
                  key: 0,
                  onToggleAuth: _cache[4] || (_cache[4] = ($event: any) => (_isRef(showLogin) //@ts-ignore
 ? showLogin.value = !_unref(showLogin) : showLogin = !_unref(showLogin))),
                  onCloseAuth: _cache[5] || (_cache[5] = ($event: any) => (_isRef(showAuthModal) //@ts-ignore
 ? showAuthModal.value = false : showAuthModal = false))
                }))
              : (_openBlock(), _createBlock(RegisrationModule, {
                  key: 1,
                  onToggleAuth: _cache[6] || (_cache[6] = ($event: any) => (_isRef(showLogin) //@ts-ignore
 ? showLogin.value = !_unref(showLogin) : showLogin = !_unref(showLogin))),
                  onClose: _cache[7] || (_cache[7] = ($event: any) => (_isRef(showAuthModal) //@ts-ignore
 ? showAuthModal.value = false : showAuthModal = false))
                }))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(showModal))
      ? (_openBlock(), _createBlock(ModalWindow, {
          key: 3,
          showbtn: true,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (_isRef(showModal) //@ts-ignore
 ? showModal.value = false : showModal = false))
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createElementVNode("p", _hoisted_4, [
              _createVNode(ButtonCustom, {
                onClick: _cache[9] || (_cache[9] = () => {_unref(store).commit('deleteToken'); _isRef(showModal) //@ts-ignore
 ? showModal.value = false : showModal = false})
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Да")
                ]),
                _: 1
              }),
              _createVNode(ButtonCustom, {
                style: {"margin-left":"0.5em"},
                onClick: _cache[10] || (_cache[10] = () => {_isRef(showModal) //@ts-ignore
 ? showModal.value = false : showModal = false})
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Нет")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})